export default {"src":"/_next/static/media/word-doc.370f2de7.svg","height":40,"width":40};